<template>
  <div>
    <el-row>
      <el-col :span="2"><div class="grid-content"></div></el-col>
      <el-col :span="20">
        <div class="title">
          <h1>Positioning, Applications, and Value of VR in Conceptual Design</h1>
        </div>
        <div class="picture">
          <img class="cover-image" src="../assets/project16_1.jpg.webp" />
        </div>
        <div class="paper_published">
          Zou, N., Gong, Q.*, Chai, Q., &amp; Chai, C. (2023). The role of virtual reality technology in conceptual design: Positioning, applications, and value. Digital Creativity, 34(1).（AHCI，学生一作）
        </div>
      </el-col>
      <el-col :span="2"><div class="grid-content"></div></el-col>
    </el-row>

    <el-row :gutter="40" style="margin-top: 50px">
      <el-col :span="2"><div class="grid-content"></div></el-col>
      <el-col :span="10">
        <div class="picture">
          <img src="../assets/project16_2.jpg.webp" />
        </div>
      </el-col>
      <el-col :span="10">
        <div class="sub-title">1 Introduction</div>
        <div class="text">
          As a key digital technology, VR has been increasingly applied in design, but its role in conceptual design has not been systematically and comprehensively reviewed. Conceptual design includes insight, generation, and decision, which are highly related to designers’ cognitive activities. By reviewing 18 years of studies, this paper connects VR’s technical features with cognitive needs in conceptual design, sorts out application tools, analyzes pros and cons, development laws, and technical values, and reveals the positioning and future trends of VR in conceptual design to promote its better integration into the early design process.
        </div>
      </el-col>
      <el-col :span="2"><div class="grid-content"></div></el-col>
    </el-row>

    <el-row :gutter="40" style="margin-top: 50px">
      <el-col :span="2"><div class="grid-content"></div></el-col>
      <el-col :span="10">
        <div class="sub-title">2 Review Process</div>
        <div class="text">
          The review process consists of four main steps. First, based on the design information cycle model, the research defines conceptual design as three phases: insight (problem analysis and inspiration exploration), generation (representation construction and modification), and decision (comparison and judgment), and clarifies the corresponding cognitive needs. Second, the study collects literature by searching databases and filters 78 representative studies from 2005 to 2022. Third, it classifies VR applications into tools such as empathy tools, inspiration tools, immersive sketching, VR-CAD systems, haptic tools, gesture modeling, virtual prototypes, and collaborative review, and analyzes advantages and limitations in each phase. Fourth, it analyzes development trends by counting annual publications, identifies two research peaks, and summarizes VR’s technical values and matching degrees of technical characteristics in different phases.
        </div>
      </el-col>
      <el-col :span="10">
        <div class="picture">
          <img src="../assets/project16_3.jpg.webp" />
        </div>
      </el-col>
      <el-col :span="2"><div class="grid-content"></div></el-col>
    </el-row>

    <el-row :gutter="40" style="margin-top: 50px">
      <el-col :span="2"><div class="grid-content"></div></el-col>
      <el-col :span="10">
        <div class="picture">
          <img src="../assets/project16_4.jpg.webp" />
        </div>
      </el-col>
      <el-col :span="10">
        <div class="sub-title">3 Conclusion</div>
        <div class="text">
          This review systematically clarifies the positioning, applications, and value of VR in conceptual design. VR effectively matches the cognitive needs of the three phases, providing immersive, intuitive, and collaborative support for designers. It has gone through technology-driven and application-oriented development stages, and its value is the most mature in the decision phase, followed by the generation phase, while the insight phase has great potential. The main limitations include high cost, insufficient accuracy, equipment constraints, and incomplete system integration. Future research should focus on whole-process support, intelligent interaction, user-centered participation, and design knowledge integration to build a more systematic and efficient VR-supported conceptual design system.
        </div>
      </el-col>
      <el-col :span="2"><div class="grid-content"></div></el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "Project16",
};
</script>

<style scoped>
.paper_published {
  margin-top: 24px;
  font-size: 15px;
  color: #333;
  font-weight: 400;
  text-align: justify;
  line-height: 1.9;
  border-bottom: 1px solid #333;
  padding-bottom: 6px;
}
.picture img {
  width: 100%;
}
.cover-image {
  width: 88% !important;
  margin: 0 auto;
  display: block;
}
.sub-title {
  margin-bottom: 20px;
  font-size: 18px;
  color: #333;
  font-weight: 400;
}
.text {
  font-size: 15px;
  color: #333;
  font-weight: 100;
  text-align: justify;
  line-height: 1.9;
}
.grid-content {
  min-height: 36px;
}
.title {
  margin-top: 100px;
  text-align: center;
}
.title h1 {
  font-size: 30px;
  font-weight: 100;
  letter-spacing: 3px;
  color: #333333;
}
</style>
